// import React, { useEffect, useState } from 'react';
// import {
//     Box,
//     Typography,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     CircularProgress,
// } from '@mui/material';
// import { useParams, useSearchParams } from 'react-router-dom';
// import { apiService, ApiService } from '@/services/api';

// interface TransactionDetail {
//     id: number;
//     day: string;
//     date: string;
//     chargebackFee: number;
//     chargebackRate: number;
//     chargebackAmount: number;
//     grossSales: number;
//     IC: number;
//     refundAmount: number;
//     refundCount: number;
//     refundFee: number;
//     reserve: number;
//     sstgFee: number;
//     transactionsCount: number;
//     transactionFee: number;
//     wireFee: number;
//     totalCost: number;
//     netPayout: number;
//     payoutAmount1: number | null;
//     payoutAmount2: number | null;
// }

// interface WeekData {
//     week_start: string;
//     week_end: string;
//     transactiondetails: TransactionDetail[];
//     grosssales: string;
//     totalIcAmount: string;
//     totalrefundCount: string;
//     totalreserveFee: string;
//     totaltransactionCount: string;
//     totalPayoutServiceCharge: string;
//     netTotalCost: string;
//     totalNetPayout: string;
//     totalTransactionFee: string;
//     totalSstgFee: string;
//     totalPayout: string;
// }

// const MerchantReport: React.FC = () => {
//     const { id } = useParams();
//     const [searchParams] = useSearchParams();
//     const month = String(searchParams.get('month') || '');
//     const year = String(searchParams.get('year') || '');

//     const [reportData, setReportData] = useState<WeekData[]>([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchReport = async () => {
//             if (!id || !month || !year) return;
//             setLoading(true);
//             try {
//                 const data = await apiService.getMerchantReport({
//                     merchantId: Number(id),
//                     month,
//                     year,
//                 });
//                 setReportData(data.data || []);
//             } catch (error) {
//                 console.error('Error fetching weekly report:', error);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchReport();
//     }, [id, month, year]);

//     if (loading) {
//         return (
//             <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
//                 <CircularProgress />
//             </Box>
//         );
//     }

//     if (!reportData.length) {
//         return (
//             <Typography sx={{ mt: 4, textAlign: 'center' }}>
//                 No data available for the selected month and year.
//             </Typography>
//         );
//     }

//     return (
//         <Box sx={{ p: 2 }}>
//             <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
//                 Merchant Weekly Report ({month}/{year})
//             </Typography>

//             {reportData.map((week, idx) => (
//                 <Box key={idx} sx={{ mb: 5 }}>
//                     <Typography
//                         variant="h6"
//                         sx={{
//                             backgroundColor: '#1976d2',
//                             color: '#fff',
//                             px: 2,
//                             py: 1,
//                             borderRadius: 1,
//                         }}
//                     >
//                         Week {idx + 1}{' '}
//                         {new Date(week.week_start).toLocaleDateString()} -{' '}
//                         {new Date(week.week_end).toLocaleDateString()}
//                     </Typography>

//                     <TableContainer component={Paper} sx={{ mt: 1 }}>
//                         <Table size="small">
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Week {idx + 1}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Trade Day
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Date
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Gross Sales
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         CB $
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         CB #
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         CB Fee
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         IC
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Refund $
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Rf #
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Refund Fee
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Reserve
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         SSTG Fee
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Tx #
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Tx Fee
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Wire Fee
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Total Cost
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Net Payout
//                                     </TableCell>
//                                     {/* Additional Columns */}
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         TBP
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Paid
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Amount
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         TRN Code
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Periodic Payout to Merchant
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Payout Period 1
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         Payout Period 2
//                                     </TableCell>
//                                 </TableRow>
//                             </TableHead>

//                             <TableBody>
//                                 <TableRow>
//                                     <TableCell
//                                         rowSpan={6}
//                                         sx={{
//                                             width: 200,
//                                             minWidth: 200,
//                                             maxWidth: 200,
//                                         }}
//                                     >
//                                         <Box
//                                             display="flex"
//                                             flexDirection="column"
//                                             gap={0.5}
//                                         >
//                                             <Box
//                                                 display="flex"
//                                                 justifyContent="space-between"
//                                                 width={180}
//                                             >
//                                                 <Typography
//                                                     variant="body2"
//                                                     fontWeight="bold"
//                                                 >
//                                                     Chargeback Fee
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                     $0.00
//                                                 </Typography>
//                                             </Box>

//                                             <Box
//                                                 display="flex"
//                                                 justifyContent="space-between"
//                                                 width={180}
//                                             >
//                                                 <Typography
//                                                     variant="body2"
//                                                     fontWeight="bold"
//                                                 >
//                                                     IC
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                     {week.totalIcAmount}%
//                                                 </Typography>
//                                             </Box>

//                                             <Box
//                                                 display="flex"
//                                                 justifyContent="space-between"
//                                                 width={180}
//                                             >
//                                                 <Typography
//                                                     variant="body2"
//                                                     fontWeight="bold"
//                                                 >
//                                                     Refund Fee
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                     ${week.totalrefundCount}
//                                                 </Typography>
//                                             </Box>

//                                             <Box
//                                                 display="flex"
//                                                 justifyContent="space-between"
//                                                 width={180}
//                                             >
//                                                 <Typography
//                                                     variant="body2"
//                                                     fontWeight="bold"
//                                                 >
//                                                     Reserve
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                     {week.totalreserveFee}%
//                                                 </Typography>
//                                             </Box>

//                                             <Box
//                                                 display="flex"
//                                                 justifyContent="space-between"
//                                                 width={180}
//                                             >
//                                                 <Typography
//                                                     variant="body2"
//                                                     fontWeight="bold"
//                                                 >
//                                                     SSTG Fee
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                     {week.totalSstgFee}%
//                                                 </Typography>
//                                             </Box>

//                                             <Box
//                                                 display="flex"
//                                                 justifyContent="space-between"
//                                                 width={180}
//                                             >
//                                                 <Typography
//                                                     variant="body2"
//                                                     fontWeight="bold"
//                                                 >
//                                                     TX Fee
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                     ${week.totalTransactionFee}
//                                                 </Typography>
//                                             </Box>

//                                             <Box
//                                                 display="flex"
//                                                 justifyContent="space-between"
//                                                 width={180}
//                                             >
//                                                 <Typography
//                                                     variant="body2"
//                                                     fontWeight="bold"
//                                                 >
//                                                     Wire Fee
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                     $0.00
//                                                 </Typography>
//                                             </Box>
//                                         </Box>
//                                     </TableCell>
//                                 </TableRow>
//                                 {week.transactiondetails.map(tx => (
//                                     <TableRow key={tx.id}>
//                                         <TableCell>{tx.day}</TableCell>
//                                         <TableCell>
//                                             {new Date(
//                                                 tx.date
//                                             ).toLocaleDateString()}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.grossSales.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.chargebackAmount.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             {tx.chargebackRate.toFixed(2)}%
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.chargebackFee.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.IC.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.refundAmount.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>{tx.refundCount}</TableCell>
//                                         <TableCell>
//                                             ${tx.refundFee.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.reserve.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.sstgFee.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             {tx.transactionsCount}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.transactionFee.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.wireFee.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.totalCost.toFixed(2)}
//                                         </TableCell>
//                                         <TableCell>
//                                             ${tx.netPayout.toFixed(2)}
//                                         </TableCell>
//                                         {/* Additional Data Cells */}
//                                         <TableCell>
//                                             {/* TBP - To Be Provided data */}-
//                                         </TableCell>
//                                         <TableCell>
//                                             {/* Paid data */}-
//                                         </TableCell>
//                                         <TableCell>
//                                             {/* Amount data */}-
//                                         </TableCell>
//                                         <TableCell>
//                                             {/* TRN Code data */}-
//                                         </TableCell>
//                                         <TableCell>
//                                             {/* Periodic Payout to Merchant data */}
//                                             -
//                                         </TableCell>
//                                         <TableCell>
//                                             {tx.payoutAmount1 !== null
//                                                 ? `$${tx.payoutAmount1.toFixed(2)}`
//                                                 : '-'}
//                                         </TableCell>
//                                         <TableCell>
//                                             {tx.payoutAmount2 !== null
//                                                 ? `$${tx.payoutAmount2.toFixed(2)}`
//                                                 : '-'}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}

//                                 {/* Totals Row */}
//                                 <TableRow
//                                     sx={{
//                                         backgroundColor: '#f5f5f5',
//                                         fontWeight: 'bold',
//                                     }}
//                                 >
//                                     <TableCell
//                                         sx={{ fontWeight: 'bold' }}
//                                     ></TableCell>
//                                     <TableCell
//                                         sx={{ fontWeight: 'bold' }}
//                                         colSpan={2}
//                                     >
//                                         Total
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         ${Number(week.grosssales).toFixed(2)}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         ${Number(week.totalIcAmount).toFixed(2)}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         {week.totalrefundCount}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         $
//                                         {Number(week.totalreserveFee).toFixed(
//                                             2
//                                         )}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         $
//                                         {Number(
//                                             week.totalPayoutServiceCharge
//                                         ).toFixed(2)}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         {week.totaltransactionCount}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell>-</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         ${Number(week.netTotalCost).toFixed(2)}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         $
//                                         {Number(week.totalNetPayout).toFixed(2)}
//                                     </TableCell>
//                                     {/* Additional Totals Columns */}
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>
//                                         -
//                                     </TableCell>
//                                 </TableRow>
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             ))}
//         </Box>
//     );
// };

// export default MerchantReport;

import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
} from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import { apiService } from '@/services/api';

interface TransactionDetail {
    id: number;
    day: string;
    date: string;
    chargebackFee: number;
    chargebackRate: number;
    chargebackAmount: number;
    grossSales: number;
    IC: number;
    refundAmount: number;
    refundCount: number;
    refundFee: number;
    reserve: number;
    sstgFee: number;
    transactionsCount: number;
    transactionFee: number;
    wireFee: number;
    totalCost: number;
    netPayout: number;
    totalWireAmount: number;
    payoutAmount1: number | null;
    payoutAmount2: number | null;
    payoutServiceCharge: number;
}
interface Charges {
    chargebackFee: number;
    ic: number;
    refundFee: number;
    sstg: number;
    txFee: number;
    wireFee: number;
    reserve: number;
}

interface WeekData {
    week_start: string;
    week_end: string;
    transactiondetails: TransactionDetail[];
    charges: Charges[];
    grosssales: string;
    totalIcAmount: string;
    totalrefundCount: string;
    totalreserveFee: string;
    totaltransactionCount: string;
    totalPayoutServiceCharge: string;
    netTotalCost: string;
    totalNetPayout: string;
    totalTransactionFee: string;
    totalSstgFee: string;
    totalPayout: string;
}

const MerchantReport: React.FC = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const month = String(searchParams.get('month') || '');
    const year = String(searchParams.get('year') || '');

    const [reportData, setReportData] = useState<WeekData[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReport = async () => {
            if (!id || !month || !year) return;
            setLoading(true);
            try {
                const data = await apiService.getMerchantReport({
                    merchantId: Number(id),
                    month,
                    year,
                });
                setReportData(data.data || []);
            } catch (error) {
                console.error('Error fetching weekly report:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchReport();
    }, [id, month, year]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!reportData.length) {
        return (
            <Typography sx={{ mt: 4, textAlign: 'center' }}>
                No data available for the selected month and year.
            </Typography>
        );
    }

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
                Merchant Weekly Report ({month}/{year})
            </Typography>

            {reportData.map((week, idx) => (
                <Box key={idx} sx={{ mb: 5 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            backgroundColor: '#1976d2',
                            color: '#fff',
                            px: 2,
                            py: 1,
                            borderRadius: 1,
                        }}
                    >
                        Week {idx + 1}{' '}
                        {new Date(week.week_start).toLocaleDateString()} -{' '}
                        {new Date(week.week_end).toLocaleDateString()}
                    </Typography>

                    <TableContainer component={Paper} sx={{ mt: 1 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        Week {idx + 1}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        Trade Day
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        Date
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 120,
                                        }}
                                    >
                                        Gross Sales
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        CB $
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        CB #
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        CB Fee
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        IC
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 100,
                                        }}
                                    >
                                        Refund $
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 80,
                                        }}
                                    >
                                        Rf #
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 120,
                                        }}
                                    >
                                        Refund Fee
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        Reserve
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 120,
                                        }}
                                    >
                                        SSTG Fee
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 100,
                                        }}
                                    >
                                        Tx #
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 100,
                                        }}
                                    >
                                        Tx Fee
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 100,
                                        }}
                                    >
                                        Wire Fee / Ach Fee
                                    </TableCell>
                                    {/* <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 100,
                                        }}
                                    >
                                        Wire Fee
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 100,
                                        }}
                                    >
                                        ACH Amount
                                    </TableCell> */}

                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 120,
                                        }}
                                    >
                                        Total Cost
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 120,
                                        }}
                                    >
                                        Net Payout
                                    </TableCell>
                                    {/* Additional Columns */}
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        TBP
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        Paid
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        Amount
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 120,
                                        }}
                                    >
                                        TRN Code
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 250,
                                        }}
                                    >
                                        Periodic Payout to Merchant
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 150,
                                        }}
                                    >
                                        Payout Period 1
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: 150,
                                        }}
                                    >
                                        Payout Period 2
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        rowSpan={
                                            week.transactiondetails.length + 1
                                        }
                                        sx={{
                                            width: 200,
                                            minWidth: 200,
                                            maxWidth: 200,
                                        }}
                                    >
                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                            gap={0.5}
                                        >
                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                width={180}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                >
                                                    Chargeback Fee
                                                </Typography>
                                                <Typography variant="body2">
                                                    $
                                                    {Number(
                                                        week?.charges[0]
                                                            ?.chargebackFee ?? 0
                                                    ).toFixed(2)}
                                                </Typography>
                                            </Box>

                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                width={180}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                >
                                                    IC
                                                </Typography>
                                                <Typography variant="body2">
                                                    {Number(
                                                        week?.charges[0]?.ic ??
                                                            0
                                                    ).toFixed(2)}
                                                    %
                                                </Typography>
                                            </Box>

                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                width={180}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                >
                                                    Refund Fee
                                                </Typography>
                                                <Typography variant="body2">
                                                    $
                                                    {Number(
                                                        week?.charges[0]
                                                            ?.refundFee ?? 0
                                                    ).toFixed(2)}
                                                </Typography>
                                            </Box>

                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                width={180}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                >
                                                    Reserve
                                                </Typography>
                                                <Typography variant="body2">
                                                    {Number(
                                                        week?.charges[0]
                                                            ?.reserve ?? 0
                                                    ).toFixed(2)}
                                                    %
                                                    {/* {Number(
                                                        week
                                                            .transactiondetails[0]
                                                            .reserve
                                                    ).toFixed(2)} */}
                                                </Typography>
                                            </Box>

                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                width={180}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                >
                                                    SSTG Fee
                                                </Typography>
                                                <Typography variant="body2">
                                                    {Number(
                                                        week?.charges[0]
                                                            ?.sstg ?? 0
                                                    ).toFixed(2)}
                                                    %
                                                </Typography>
                                            </Box>

                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                width={180}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                >
                                                    TX Fee
                                                </Typography>
                                                <Typography variant="body2">
                                                    $
                                                    {Number(
                                                        week?.charges[0]
                                                            ?.txFee ?? 0
                                                    ).toFixed(2)}
                                                </Typography>
                                            </Box>

                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                width={180}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                >
                                                    Wire Fee
                                                </Typography>
                                                <Typography variant="body2">
                                                    $
                                                    {Number(
                                                        week?.charges[0]
                                                            ?.wireFee ?? 0
                                                    ).toFixed(2)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                                {week.transactiondetails.map(tx => (
                                    <TableRow key={tx.id}>
                                        <TableCell>{tx.day}</TableCell>
                                        <TableCell>
                                            {new Date(
                                                tx.date
                                            ).toLocaleDateString()}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(
                                                tx?.grossSales ?? 0
                                            ).toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(
                                                tx?.chargebackAmount ?? 0
                                            ).toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                            {Number(
                                                tx?.chargebackRate ?? 0
                                            ).toFixed(2)}
                                            %
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(
                                                tx?.chargebackFee ?? 0
                                            ).toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                            ${Number(tx?.IC ?? 0).toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(
                                                tx?.refundAmount ?? 0
                                            ).toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                            {tx?.refundCount ?? 0}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(tx?.refundFee ?? 0).toFixed(
                                                2
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(tx?.reserve ?? 0).toFixed(
                                                2
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(tx?.sstgFee ?? 0).toFixed(
                                                2
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {tx?.transactionsCount ?? 0}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(
                                                tx?.transactionFee ?? 0
                                            ).toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(
                                                tx?.payoutServiceCharge ?? 0
                                            ).toFixed(2)}
                                        </TableCell>
                                        {/* <TableCell>
                                            $
                                            {Number(
                                                tx?.wireAmount ?? 0
                                            ).toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(tx?.achFee ?? 0).toFixed(2)}
                                        </TableCell> */}
                                        <TableCell>
                                            $
                                            {Number(tx?.totalCost ?? 0).toFixed(
                                                2
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            $
                                            {Number(tx?.netPayout ?? 0).toFixed(
                                                2
                                            )}
                                        </TableCell>
                                        {/* Additional Data Cells */}
                                        <TableCell>-</TableCell>
                                        <TableCell>N/A</TableCell>
                                        <TableCell>N/A</TableCell>
                                        <TableCell>N/A</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>
                                            {tx?.payoutAmount1 != null
                                                ? `$${Number(tx.payoutAmount1).toFixed(2)}`
                                                : '-'}
                                        </TableCell>
                                        <TableCell>
                                            {tx?.payoutAmount2 != null
                                                ? `$${Number(tx.payoutAmount2).toFixed(2)}`
                                                : '-'}
                                        </TableCell>
                                    </TableRow>
                                ))}

                                {/* Totals Row */}
                                <TableRow
                                    sx={{
                                        backgroundColor: '#f5f5f5',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell>
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                        colSpan={2}
                                    >
                                        Total
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        ${Number(week.grosssales).toFixed(2)}
                                    </TableCell>
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell>
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell>
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        ${Number(week.totalIcAmount).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        $
                                        {Number(
                                            week.transactiondetails.reduce(
                                                (sum, tx) =>
                                                    sum + tx.refundAmount,
                                                0
                                            )
                                        ).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        {week.totalrefundCount}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        $
                                        {Number(
                                            week.transactiondetails.reduce(
                                                (sum, tx) => sum + tx.refundFee,
                                                0
                                            )
                                        ).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        $
                                        {Number(week.totalreserveFee).toFixed(
                                            2
                                        )}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        ${Number(week.totalSstgFee).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        {week.totaltransactionCount}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        $
                                        {Number(
                                            week.totalTransactionFee
                                        ).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        $
                                        {Number(
                                            week.totalPayoutServiceCharge
                                        ).toFixed(2)}
                                    </TableCell>
                                    {/* <TableCell sx={{ fontWeight: 'bold' }}>
                                        $
                                        {Number(
                                            week.transactiondetails
                                                .totalWireAmount ?? 0
                                        ).toFixed(2)}
                                    </TableCell>
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell> */}

                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        ${Number(week.netTotalCost).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        $
                                        {Number(week.totalNetPayout).toFixed(2)}
                                    </TableCell>
                                    {/* Additional Totals Columns */}
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell>
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell>
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell>
                                    <TableCell
                                        sx={{ fontWeight: 'bold' }}
                                    ></TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        ${Number(week.totalPayout).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        -
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        -
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            ))}
        </Box>
    );
};

export default MerchantReport;
